import _ from 'lodash';
import { CardsMarketplaceOffer } from 'src/types/marketplace';
import { MethodologyPoints } from '../constants';
import { calculateScore, calculateMonthlySpend } from './shared';
import { CalculatePoints, Question, MatchScore } from './types';
import { CalculateMethodology } from '../utils';
import { StudentSpendingCategories } from 'src/types/inputs';

const { TWENTY_ONE_POINTS, THIRTEEN_POINTS, ZERO_POINTS } = MethodologyPoints;

export const calculateStudentCategories: CalculatePoints = (
  { studentSpendingCategories },
  offer: CardsMarketplaceOffer
) => {
  const numberOfSelections = studentSpendingCategories?.length;
  if (!numberOfSelections) {
    return ZERO_POINTS;
  }

  const rewards = offer?.details?.rewards;
  const categories = rewards?.filter((reward) => {
    if (
      reward?.recommendation_category &&
      studentSpendingCategories?.includes(
        reward?.recommendation_category as string as StudentSpendingCategories
      )
    ) {
      return reward?.rate && reward.rate > 1;
    }
    return false;
  });

  switch (categories?.length) {
    case 2:
      return TWENTY_ONE_POINTS;
    case 1:
      return numberOfSelections === 2 ? THIRTEEN_POINTS : TWENTY_ONE_POINTS;
    default:
      return ZERO_POINTS;
  }
};

const getQuestions = (): Question[] => [
  {
    availablePoints: TWENTY_ONE_POINTS,
    calculate: calculateStudentCategories,
  },
  {
    availablePoints: THIRTEEN_POINTS,
    calculate: calculateMonthlySpend,
  },
];

const getStudentVariantScore: CalculateMethodology = (
  answers,
  offer
): MatchScore => calculateScore(answers, offer, getQuestions());

export default getStudentVariantScore;
